import React, { useState, useEffect } from 'react';
import { noteApi } from '../../services/consts';
// import TemplateEditor from './wysiwyg';
import {
   Button,
   Table,
   Input,
   FormGroup
} from 'reactstrap';
import Modal from 'react-bootstrap/Modal'
import { tokenHeader, getUserToken, getCurrentUser } from "../../services/user-service";
import { dateFormat } from '../../services/prospects';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = noteApi;

var NotesModal = (props) => {
    // console.log(">>props"+JSON.stringify(props));
    const [note, setNotes] = useState('');
    const [type, setType] = useState('');
    const [notesIsValid, setNotesIsValid] = useState(false);
    const [typeIsValid, setTypeIsValid] = useState(false);
    const [currentUserId, setCurrentUserId] = useState('');
    // const [prospectNotes, setProspectNotes] = useState(props.status().prospectNotes);
    const [loaded, setLoaded] = useState(false);
    // const [prospectId, setId] = useState(props.status().id);
    // console.log("id>"+JSON.stringify(props.status().id))
 
 
    var addNotes = () => {
       // e.preventDefault();
       let methodType = 'post';
       var notes = {
          note: note,
          type: type,
          prospectId: props.status().id,
          addedByUserId: currentUserId
       };
       if (notes.note == '') {
          toast.error('Note is required');
          return setNotesIsValid(true);
       } else if (notes.type == '') {
          toast.error('Type is required');
          return setTypeIsValid(true);
       }
       fetch(apiEndPoint, {
          method: methodType,
          body: JSON.stringify(notes),
          headers: {
             'Accept': 'application/json',
             'Content-Type': 'application/json',
             [tokenHeader]: getUserToken()
          }
       }).then(function (result) {
          // console.log("id>>" + props.prospectId)
          toast.success("Note added.");
          // handleClose(true);
          props.visibileModal(false);
       })
    };
    var onHandleChange = (e) => {
       // console.log("e.target.name:" + e.target.name);
       if (e.target.name == 'note') {
          setNotes(e.target.value);
       } else if (e.target.name == 'type') {
          setType(e.target.value);
       }
    }
 
    useEffect((e) => {
 
       if (!loaded) {
          // getProspectNotesData(props.status().id);
          setLoaded(true);
          getCurrentUser().then((result) => {
             if (result != null) {
                // setEmail(result.email);
                setCurrentUserId(result.id);
             }
          })
       }
    });
    return (
       <div>
          <ToastContainer
             position="top-right"
             autoClose={2000}
             hideProgressBar={true}
             newestOnTop={false}
             closeOnClick
             rtl={false}
             pauseOnFocusLoss
             draggable
             pauseOnHover
          />
          <Modal show={props.status().show} size="lg">
             <Modal.Header>
                <Modal.Title>Add Note</Modal.Title>
                <Button color="danger" onClick={() => {
                   props.visibileModal(false);
                }}><i className="mdi mdi-close-circle"></i></Button>
                {/* <i style={{color: 'red'}} className="mdi mdi-close-circle mdi-24px" onClick={() => {
                   props.visibileModal(false);
                }}></i> */}
             </Modal.Header>
             <Modal.Body>
                <FormGroup>
                   <Input type="textarea" placeholder="Add notes here ..." onChange={onHandleChange} name="note" id="note" />
                </FormGroup>
                <FormGroup>
                   <Input type="select" onChange={onHandleChange} value={type} name="type" id="type">
                      <option hidden>Select Type</option>
                      <option>New</option>
                      <option>Reference</option>
                      <option>Followup</option>
                      <option>Close</option>
                      <option>Future</option>
                      <option>Interested</option>
                      <option>Not Interested</option>
                   </Input>
                </FormGroup>
             </Modal.Body>
             <Modal.Footer>
                <Button color="secondary" onClick={() => {
                   props.visibileModal(false);
                }}>
                   Cancel
                </Button>
                <Button color="primary" onClick={() => { addNotes(props.status().id) }}>
                   Add
                </Button>
             </Modal.Footer>
             {/* <Modal.Header>
                <Modal.Title>Notes History</Modal.Title>
             </Modal.Header> */}
             <Modal.Body>
                {/* Notes:{JSON.stringify(props.status().prospectNotes)} */}
                <Table style={{ tableLayout: 'fixed' }} striped hover size="sm">
                   <thead>
                      <tr>
                         <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Notes</th>
                         <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '6.5rem' }}>Type</th>
                         <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '6rem' }}>Date</th>
                      </tr>
                   </thead>
                   <tbody>
                      {props.status().prospectNotes.length > 0 ? props.status().prospectNotes.map(item => (
                         <tr key={item.id} >
                            <td style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                               {item.note ? item.note : '-'}
                            </td>
                            <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                               {item.type ? item.type : '-'}
                            </td>
                            <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                               {item.createdAt ? dateFormat(item.createdAt) : '-'}
                            </td>
                         </tr>
                      )) : <tr><td colSpan={3} style={{ textAlign: 'center' }}><b>No Notes Found</b></td></tr>}
 
                   </tbody>
                </Table>
             </Modal.Body>
          </Modal>
       </div>
    );
 }

 export default NotesModal;